import React from 'react';

const OrganizationDetails = () => {
  return (
    <section className="mb-5 pt-3">
      
      {/* Custom Styles & Premium Google Font (Poppins) */}
      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800&display=swap');
          
          .org-card {
            font-family: 'Poppins', sans-serif;
            border-radius: 1.25rem;
            background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
            border: 1px solid #e2e8f0;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          
          /* Hover karne par card thoda upar uthega aur shadow aayegi */
          .org-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 20px 40px rgba(15, 23, 42, 0.08) !important;
            border-color: #bae6fd;
          }

          .org-title {
            color: #0f172a;
            font-weight: 700;
            font-size: 1.35rem;
          }

          .org-label {
            color: #0284c7; /* Vibrant Blue for color */
            font-size: 0.75rem;
            letter-spacing: 1.5px;
            font-weight: 600;
            text-transform: uppercase;
            margin-bottom: 0.25rem;
          }

          .org-value {
            color: #1e293b;
            font-weight: 600;
            font-size: 1.05rem;
          }

          .org-value.large {
            font-size: 1.3rem;
            color: #0369a1; /* Deep Blue for main values */
            font-weight: 800;
          }
          
          .card-top-line {
            height: 6px;
            background: linear-gradient(90deg, #0ea5e9, #2563eb);
            border-radius: 1.25rem 1.25rem 0 0;
          }
        `}
      </style>

      <div className="row g-4">
        
        {/* Card 1: NPO Details */}
        <div className="col-lg-4 col-md-6">
          <div className="card h-100 border-0 shadow-sm org-card position-relative">
            <div className="card-top-line position-absolute top-0 w-100"></div>
            <div className="card-body p-4 p-xl-5 mt-2">
              <h4 className="org-title mb-4 pb-3 border-bottom">NPO Details</h4>
              
              <div className="mb-4">
                <p className="org-label">DARPAN ID</p>
                <p className="org-value large mb-0">UP/2025/0931093</p>
              </div>
              
              <div>
                <p className="org-label">Registration Date</p>
                <p className="org-value mb-0">20-12-2025</p>
              </div>
            </div>
          </div>
        </div>

        {/* Card 2: Registration Details */}
        <div className="col-lg-4 col-md-6">
          <div className="card h-100 border-0 shadow-sm org-card position-relative">
            <div className="card-top-line position-absolute top-0 w-100"></div>
            <div className="card-body p-4 p-xl-5 mt-2">
              <h4 className="org-title mb-4 pb-3 border-bottom">Registration Details</h4>
              
              <div className="row g-4">
                <div className="col-6">
                  <p className="org-label">Registered With</p>
                  <p className="org-value mb-0">Sub-Registrar</p>
                </div>
                <div className="col-6">
                  <p className="org-label">Type of NPO</p>
                  <p className="org-value mb-0">Trust</p>
                </div>
                <div className="col-6">
                  <p className="org-label">City / State</p>
                  <p className="org-value mb-0">Jaunpur, UP</p>
                </div>
                <div className="col-6">
                  <p className="org-label">Date of Reg.</p>
                  <p className="org-value mb-0">16-12-2024</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Card 3: Contact Details */}
        <div className="col-lg-4 col-md-12">
          <div className="card h-100 border-0 shadow-sm org-card position-relative">
            <div className="card-top-line position-absolute top-0 w-100"></div>
            <div className="card-body p-4 p-xl-5 mt-2 d-flex flex-column justify-content-center">
              <h4 className="org-title mb-4 pb-3 border-bottom">Contact Details</h4>
              
              <div className="mb-4">
                <p className="org-label">Registered Address</p>
                <p className="org-value mb-0" style={{ fontSize: '0.95rem', lineHeight: '1.6' }}>
                  64 Pura Nand Lal, Machhalishahar,<br/>
                  Jaunpur, Uttar Pradesh - 222143
                </p>
              </div>
              
              <div className="mb-4">
                <p className="org-label">Email Address</p>
                <a href="mailto:vkpaldoc777@gmail.com" className="org-value text-decoration-none text-break" style={{ color: '#0369a1' }}>
                  vkpaldoc777@gmail.com
                </a>
              </div>
              
              <div>
                <p className="org-label">Mobile No.</p>
                <p className="org-value large mb-0">+91 7007205910</p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default OrganizationDetails;